import { FC } from 'react';
import { Descriptions } from 'antd';
import styled from 'styled-components';
import { getConfidentialityRuleSourceLabel } from '../../utils';
import { AlgorithmSourcesFormDataType } from '../schema/types';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmSourcesConfidentialityRule.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-sources-confidentiality-rule'
);
addTranslations(translations);

export interface AlgorithmSourcesConfidentialityRuleProps {
  algorithmSources: AlgorithmSourcesFormDataType;
}

export const AlgorithmSourcesConfidentialityRule: FC<
  AlgorithmSourcesConfidentialityRuleProps
> = (props) => {
  const { algorithmSources } = props;
  const { sources, confidentialityRule } = algorithmSources;
  const { t } = useTranslation();

  return (
    <StyledDescriptions
      layout="vertical"
      items={[
        {
          key: 'confidentialityRule',
          label: t('label'),
          children: getConfidentialityRuleSourceLabel(
            confidentialityRule,
            sources
          ),
        },
      ]}
    />
  );
};

const StyledDescriptions = styled(Descriptions)`
  th {
    padding-bottom: 0 !important;
  }
`;
